// extracted by mini-css-extract-plugin
export var required = "_fs-0";